import { render, staticRenderFns } from "./FiltrosHistorico.vue?vue&type=template&id=3ae7d23c&scoped=true"
import script from "./FiltrosHistorico.vue?vue&type=script&lang=js"
export * from "./FiltrosHistorico.vue?vue&type=script&lang=js"
import style0 from "./FiltrosHistorico.vue?vue&type=style&index=0&id=3ae7d23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae7d23c",
  null
  
)

export default component.exports